// Load images
import './img/money-back-guarantee.svg';
import './img/paypal-verified.svg';
import './img/ssl-secure-encription.svg';

// Load CSS
import './scss/main.scss';

// Import
import { isCheckout, onReady } from './js/utilities'; 
import Fields            from './js/fields';
import StickySidebar     from './js/sticky-sidebar';

// Invoke classes when the DOM is ready
onReady(() => {
	// Check if the current page is the checkout page
	if ( isCheckout() ){
		new Fields();
		new StickySidebar();
	}
});